<ion-item lines="none" class="ion-no-padding">
  <ion-label class="ion-bold-text"> {{ title | translate }}</ion-label>
  <ion-text color="primary">
    <h2 class="ion-bold-text">
      {{ data || '--' }}
    </h2>
  </ion-text>
</ion-item>
